import styled from 'styled-components';
import { DatePicker, Slider } from 'antd';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';
const { RangePicker } = DatePicker;

export const StyledRangePicker = styled(RangePicker)`
    width: 100%;
`;

export const StyledSlider = styled(Slider)`
    flex-grow: 1;
    width: 97%;
`;
export const Wrapper = styled.div`
    overflow: hidden;
    display: flex;
    position: fixed;
    flex-direction: column;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    padding: 10px 25px 25px 25px;
    width: 100%;
    min-width: 300px;
    max-width: 430px;
    height: 600px;
    background: #f7f7f7;
    border-radius: 5px;
`;
export const WrapSelect = styled.div`
    align-self: flex-start;
    ${flexMixin('column', 'center', 'center')}
    width: 100%;
    .ant-select-selection-item-content {
        height: 24px;
        line-height: 22px;
    }
`;

export const HeaderTitle = styled.div`
    width: 100%;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 500,
    })};
    ${flexMixin('row', 'space-between', 'flex-start')}
    color: ${colors.grey};
    height: 45px;
`;
export const Title = styled.div`
    ${textMixin({
        fontSize: '18px',
        fontWeight: 700,
    })};
    margin-top: 15px;
    line-height: 20px;
    ${flexMixin('column', 'center', 'flex-end')}
`;
export const CloseBtn = styled.button`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    color: #8f8f8f;
    border: none;
    background: #f7f7f7;
    ${flexMixin('column', 'flex-start', 'flex-start')}
    cursor: pointer;

    &:hover {
        color: #5e5e5e;
    }
`;
export const FormContainer = styled.form`
    ${flexMixin('row', 'space-between', 'flex-start')}
    padding: 21px 0 0 0;
    height: 100%;
`;

export const WrapBoxForm = styled.div`
    width: 100%;
    ${flexMixin('column', 'space-between', 'center')}
    height: 100%;

    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 15px;
        color: ${colors.grey};
    }
`;

export const StyledFooter = styled.div`
    align-items: center;
    width: 100%;
`;

export const StyledButtonSend = styled.button`
    ${flexMixin('row', 'center', 'center')}
    cursor: pointer;
    height: 40px;
    width: 100%;
    background: #a7388e;
    border-radius: 5px;
    border: none;

    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        text-align: center;
        color: ${colors.cleanWhite};
    }
    &:hover {
        background: #97267d;
    }
`;
export const FormItemsContainer = styled.div`
    ${flexMixin('column', 'center', 'flex-start')}
    gap: 9px;
    width: 100%;
`;

export const FormItemContainer = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    width: 100%;
`;

export const FormItem = styled.div`
    width: 90%;
`;
